import React, { useCallback, useState } from "react";
import { Form, Input, Button, Card, Typography, message, Result } from "antd";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import httpClient from "../../api/httpClient";
import { ROUTES } from "../../constant/routes";
import { parseError } from "../../utils/shared";
import StyledCard from "../../components/generic/StyledCard";

const ResetPassword = () => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const token = searchParams.get("token");

  const onFinish = useCallback(
    async (values) => {
      try {
        if (!token) return message.error("Invalid or missing reset token.");

        setLoading(true);

        await httpClient.publicPost("forget-password", {
          type: "reset",
          token,
          new_password: values?.new_password,
        });

        message.success("Password reset successfully!");

        setSuccess(true);
      } catch (error) {
        parseError(error, true);
      } finally {
        setLoading(false);
      }
    },
    [token],
  );

  return (
    <div className="auth-right">
      {!token ? (
        <Result
          status="error"
          title="Invalid Reset Link"
          subTitle="This password reset link is invalid or has expired."
          extra={
            <Button type="primary" onClick={() => navigate(ROUTES.SIGNIN)}>
              Back to Login
            </Button>
          }
        />
      ) : success ? (
        <Result
          status="success"
          title="Password Reset Successful"
          subTitle="Your password has been updated. You can now log in."
          extra={
            <Button type="primary" onClick={() => navigate(ROUTES.SIGNIN)}>
              Go to Login
            </Button>
          }
        />
      ) : (
        <>
          <div className="right-header">
            <h2>Reset your password 🔑</h2>
            <p>Create a new password to regain access to your account</p>
          </div>
          <Form layout="vertical" onFinish={onFinish}>
            <Form.Item
              label="New Password"
              name="new_password"
              rules={[
                { required: true, message: "Please enter new password!" },
                { min: 8, message: "Minimum 8 characters required!" },
              ]}
              hasFeedback
            >
              <Input.Password placeholder="Enter new password" />
            </Form.Item>

            <Form.Item
              label="Confirm Password"
              name="confirm_password"
              dependencies={["password"]}
              hasFeedback
              rules={[
                { required: true, message: "Please confirm password!" },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("new_password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error("Passwords do not match!"));
                  },
                }),
              ]}
            >
              <Input.Password placeholder="Confirm new password" />
            </Form.Item>

            <Form.Item style={{ marginTop: "1.5rem" }}>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                disabled={loading}
                block
              >
                Reset Password
              </Button>
            </Form.Item>

            <div className="text-gray login-link text-center">
              Remember your password?
              <Link className="text-primary" to={ROUTES.SIGNIN}>
                &nbsp;Sign In
              </Link>
            </div>
          </Form>
        </>
      )}
    </div>
  );
};

export default ResetPassword;
